var map = {
	"./100.jpg": 621,
	"./100.png": 7453,
	"./BIF.jpeg": 7696,
	"./b.png": 1446,
	"./buld.jpg": 4281,
	"./cisco.png": 9953,
	"./codeInLogo.png": 7873,
	"./codeuino.jpg": 8314,
	"./coursera_logo.png": 1170,
	"./deeplearning_ai_logo.png": 9575,
	"./googleAssistant.jpg": 1659,
	"./google_logo.png": 9389,
	"./hong_kong.png": 9902,
	"./icfoods.png": 2707,
	"./icl.png": 8604,
	"./ino.png": 7192,
	"./intel_logo.jpg": 8504,
	"./linuxworld.jpeg": 4009,
	"./northwestern.png": 7603,
	"./osulogo.svg": 522,
	"./quicko.jpg": 6458,
	"./sal.png": 5016,
	"./stanford_logo.png": 6691,
	"./ucb.webp": 5502,
	"./ucm.png": 2721,
	"./usg.png": 7067,
	"./vitlogo.jpeg": 5293,
	"./vitlogo.png": 4304,
	"./wisel.jpeg": 5765,
	"./wrighter.jpg": 8296,
	"./yeblogo.png": 5685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;